/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DBase } from "./d-base";

export interface DMenuItemBaseSelection {
	add(item: DBase): void;
}
